import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "../../popover";
import MagnifyingGlass from "../../../assets/icons/magnifying-glass-small-gray.svg";
import NumberFilter from "../number-filter";
import TableFilterState from "./table-filter-state";

type PopoverNumberFilterProps<T = any> = {
  filterState: TableFilterState<T>;
  placeholder?: string | null;
  title?: string | null;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

const PopoverNumberFilter = <T extends Record<string, any>>({
  filterState,
  placeholder,
  title,
  isOpen,
  onOpenChange
}: PopoverNumberFilterProps<T>) => {
  // Check if filter has value
  const hasValue = filterState.filter[filterState.filterKey] && filterState.filter[filterState.filterKey].toString().trim() !== '';
  
  // Internal state for popover open/close
  const [internalOpen, setInternalOpen] = useState(false);

  // Use controlled state if provided, otherwise use internal state
  const controlledOpen = isOpen !== undefined ? isOpen : internalOpen;
  const controlledOnOpenChange = onOpenChange || setInternalOpen;

  const handleOpenChange = (newOpen: boolean) => {
    controlledOnOpenChange(newOpen);
  };

  return (
    <Popover open={controlledOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <img className="ml-2 w-3 cursor-pointer" src={MagnifyingGlass} alt="Search" />
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2">
        <NumberFilter
          value={filterState.filter[filterState.filterKey] || ""}
          onApply={val =>
            filterState.setFilter(prev => ({
              ...prev,
              [filterState.filterKey]: val,
            }))
          }
          onClear={() =>
            filterState.setFilter(prev => ({
              ...prev,
              [filterState.filterKey]: null,
            }))
          }
          onChange={() => {}}
          placeholder={placeholder || `Search...`}
          title={title || null}
        />
      </PopoverContent>
    </Popover>
  );
};

export default PopoverNumberFilter;
